/**
 * VendorProductVariantService
 * Service for managing vendor product variants
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for vendor product variant CRUD operations with product-specific queries
 */
export class VendorProductVariantService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VendorProductVariantService.DEFAULT_SERVICE_PATH,
            basePath: VendorProductVariantService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get all variants for a specific product
     * @param productId - Product ID
     * @returns Array of vendor product variant views
     */
    async getByProduct(productId) {
        const response = await this.getByProductRaw(productId);
        return response.data ?? [];
    }
    /**
     * Get all variants for a specific product with full response
     * @param productId - Product ID
     * @returns ResponseData with array of vendor product variant views
     */
    getByProductRaw(productId) {
        const url = this.buildUrl(`product/${productId}`);
        return this.http.get(url);
    }
}
VendorProductVariantService.DEFAULT_SERVICE_PATH = 'vendor-catalogs';
VendorProductVariantService.BASE_PATH = 'api/vendor-product-variants';
//# sourceMappingURL=VendorProductVariantService.js.map